function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var purchaseService = require("./purchaseservice.js");
var taxService = require("./module/PTFs/tax.js");
var feebusterService = require('./module/PTFs/feebuster.js');
var feeService = require("./module/PTFs/fee.js");
var priceoverrideService = require('./module/PTFs/priceoverride.js');
var promoService = require("./module/PTFs/promo.js");
var freeproductsService = require("./module/PTFs/freeproducts.js");
var manualdiscountService = require("./module/PTFs/manualdiscount.js");
var modifierService = require("./module/PTFs/modifier.js");
var discountontotalService = require("./module/PTFs/discountontotal.js");
var myoverrides = [];
var mypromos = [];
var redemptionsUpcList = [];
var _require = require("./utils.js"),
  removeGetPriceFromFeebusterPTF = _require.removeGetPriceFromFeebusterPTF,
  round = _require.round;
function _addModifiersPriceTaxFeeAdjusters(purchase) {
  var modifierGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!modifierGroups || !purchase.modifiers) {
    return;
  }
  var selectedModifiers = _generateModifierInfo(purchase.modifiers, purchase.item_groups_list, modifierGroups);
  Object.keys(selectedModifiers).forEach(function (group) {
    selectedModifiers[group].forEach(function (modifier) {
      purchaseService.priceTaxFeeAdjusters.push(new modifierService.priceTaxFeeAdjuster(modifier, purchase.uuid, group));
    });
  });
}
function _addPromosPtfs() {
  var promos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  /* just in case we might want to call it from outside this service without a parameter as
   * "mypromos" is a private variable
   * remove the old promo PTFs - if getActivePromos called this, the PTFs might be out of date
   */
  promos = promos || mypromos;
  purchaseService.priceTaxFeeAdjusters = purchaseService.priceTaxFeeAdjusters.filter(function (a) {
    return a.name !== 'promo';
  });
  // re-initialize the promo ptf id counter
  promoService.priceTaxFeeAdjuster.nextId = 0;
  purchaseService.priceTaxFeeAdjusters.push(
  // eventually we will have a flag for pre / post tax instead of checking extpromoid
  new promoService.priceTaxFeeAdjuster({
    promos: promos.filter(function (a) {
      return !a.extpromoid && !a.post_tax;
    }),
    positioning: 'pretax'
  }),
  /* we must remember that no New Price promo can be post tax so we must filter those from the
   * next selection - eventually
   */
  new promoService.priceTaxFeeAdjuster({
    promos: promos.filter(function (a) {
      return a.extpromoid || a.post_tax;
    }),
    positioning: 'posttax'
  }));
}
/*
 * Originally, p.maxoffers contains the maximum number of times an offer can be excercised
 * On offers redemptions which can't be traced to a customer this means that a customer can exercise
 * the offer over several baskets
 * The following function adjusts this value for offer redemptions which can be traced to a customer
 * i.e. for which we know how many times they have redeemed them
 * This is only possible for BR offers which can be traced via their BR number being recorded in a
 * table of redeemed offers
 * The function actually changes the value of "p.maxoffers" - i.e. on the product field
 * Note that the original value is copied to a new field "p.maxoffers_orig" at initialization in the
 * getActivePromos function below
 */

function _adjustExternalPromos(localPromoUsage, cloudPromoUsage) {
  var _loop = function _loop() {
    // ...only for external promos
    if (!mypromos[pndx].extpromoid) {
      return 1; // continue
    }
    var p = mypromos[pndx];

    // ...what's the local usage for this promo ?
    var localExcercisedOffers = 0;
    localPromoUsage.forEach(function (externalPromoItem) {
      if (externalPromoItem.extpromoid == p.extpromoid) {
        localExcercisedOffers = externalPromoItem.exercised_offers;
      }
    });
    if (localExcercisedOffers >= p.maxoffers) {
      p.maxoffers = -1;
    } else {
      var cloudExcercisedOffers = 0;
      cloudPromoUsage.forEach(function (externalPromoItem) {
        if (externalPromoItem.extpromoid == p.extpromoid) {
          cloudExcercisedOffers = externalPromoItem.exercised_offers;
        }
      });
      if (cloudExcercisedOffers >= p.maxoffers) {
        p.maxoffers = -1;
      } else {
        p.maxoffers -= Math.max(localExcercisedOffers, cloudExcercisedOffers);
      }
    }
  };
  // ...adjust remaining offers based on what we found
  for (var pndx = 0; pndx < mypromos.length; ++pndx) {
    if (_loop()) continue;
  }
}
function _calculatePriceTaxFeeAdjusters(which) {
  purchaseService.priceTaxFeeAdjusters.filter(function (a) {
    return !['ebt', 'taxfreesale'].includes(a.name);
  }).sort(function (a, b) {
    return Math.sign(a.priority - b.priority);
  }).forEach(function (a) {
    if (which !== 'justcash') {
      a.calculate(purchaseService.purchases);
    }
    if (which !== 'justcc' && a.name !== 'feebuster' && purchaseService.feeBusterConfig.enabled) {
      a.calculate(purchaseService.getCashPricePurchases());
    }
  });
  purchaseService.priceTaxFeeAdjusters.filter(function (a) {
    return !['ebt', 'taxfreesale'].includes(a.name);
  }).sort(function (a, b) {
    return Math.sign(a.priority - b.priority);
  }).forEach(function (a) {
    if (!a.calculateInt) {
      console.error(a.name + " has no calculateInt function!\nOn the simplest level this can be done by haveing your PTF class\nextend ptfService.priceTaxFeeAdjusterBase");
      return;
    }
    if (which !== 'justcash') {
      a.calculateInt(purchaseService.purchases);
    }
    if (which !== 'justcc' && a.name !== 'feebuster' && purchaseService.feeBusterConfig.enabled) {
      a.calculateInt(purchaseService.getCashPricePurchases());
    }
  });

  // some PTFs must be calculated after all other values have been rounded
  purchaseService.priceTaxFeeAdjusters.filter(function (a) {
    return ['ebt', 'taxfreesale'].includes(a.name);
  }).sort(function (a, b) {
    return a.priority - b.priority;
  }).forEach(function (a) {
    if (which !== 'justcash') {
      a.calculate(purchaseService.purchases);
      a.calculateInt(purchaseService.purchases);
    }
    if (which !== 'justcc' && a.name !== 'feebuster' && purchaseService.feeBusterConfig.enabled) {
      a.calculate(purchaseService.getCashPricePurchases());
      a.calculateInt(purchaseService.getCashPricePurchases());
    }
  });
}
function _doPriceOverride(ov) {
  var item = purchaseService.purchases.find(function (_) {
    return _.upc === ov.upc;
  });
  var newprice = ov.price;
  var newskuqty = item.skuqty;
  if (item.priceTaxFeeAdjustments) {
    var priceoverridePtf = item.priceTaxFeeAdjustments.find(function (a) {
      return a.name === 'priceoverride';
    });
    if (priceoverridePtf) {
      newprice = item.intCcPrice + priceoverridePtf.price;
      newskuqty = priceoverridePtf.extra.qty;
    }
  }
  var priceToSet = _feeBusterAdjust(newprice, item.dept);
  var priceoverridePriceTaxFeeAdjuster = purchaseService.priceTaxFeeAdjusters.find(function (a) {
    return a.name === 'priceoverride';
  });
  priceoverridePriceTaxFeeAdjuster.addPriceoverride(item.upc, priceToSet, newskuqty);
  _setOverride(ov.upc, ov.qty, priceToSet);
}
function _export(items, _ref) {
  var basket_data = _ref.basket_data,
    delivery_amount = _ref.delivery_amount;
  var cashDiscount = purchaseService.priceIncrease && purchaseService.feeBusterConfig.enabled;
  var deliveryAmount = delivery_amount || 0;
  var total = purchaseService.totals.total() + deliveryAmount;
  var result = Object.assign({}, _objectSpread({
    items: items,
    totals: _objectSpread({
      authorizedAmount: _getAuthorizedAmount(total),
      br: purchaseService.totals.promos('br'),
      coupons: purchaseService.totals.promos('coupons'),
      deliveryAmount: delivery_amount,
      discount: purchaseService.totals.manualdiscountAndPriceoverride(),
      driverTip: purchaseService.totals.driverTip(),
      fee: purchaseService.totals.fee(),
      promo: purchaseService.totals.promos('promo'),
      saving: purchaseService.totals.promos(),
      serviceFee: purchaseService.totals.serviceFee(),
      storeTip: purchaseService.tipsInformations.tipsamt,
      subTotal: purchaseService.totals.subtotal() + deliveryAmount,
      subtotal: purchaseService.totals.subtotal() + deliveryAmount,
      tax: purchaseService.totals.tax(),
      total: total,
      totalSpentForPoints: purchaseService.totals.totalSpentForPoints(false, true)
    }, cashDiscount && {
      cash: {
        br: purchaseService.totals.promos('br', 'cash'),
        discount: purchaseService.totals.manualdiscountAndPriceoverride('cash'),
        coupons: purchaseService.totals.promosCash('coupons'),
        fee: purchaseService.totals.fee('cash'),
        promo: purchaseService.totals.promosCash('promo'),
        saving: purchaseService.totals.promosCash(),
        serviceFee: purchaseService.totals.serviceFee(),
        storeTip: purchaseService.tipsInformations.cashtipsamt,
        subtotal: purchaseService.totals.subtotal('cash'),
        tax: purchaseService.totals.tax('cash'),
        total: purchaseService.totals.total('cash'),
        totalSpentForPoints: purchaseService.totals.totalSpentForPoints('cash', true)
      }
    })
  }, basket_data && {
    basketdata: {
      payments: purchaseService.payments,
      purchases: delivery_amount ? [].concat(_toConsumableArray(purchaseService.purchases), [items.deliveryitem]) : purchaseService.purchases.slice(0),
      priceTaxFeeAdjusters: purchaseService.priceTaxFeeAdjusters,
      basket: purchaseService.basket,
      // null as well
      overrides: myoverrides,
      reg: purchaseService.reg,
      brnumber: purchaseService.reg.brnumber,
      // storefront passes in true always
      tipsInformations: purchaseService.tipsInformations
    }
  }));
  purchaseService.clearRegister();
  return result;
}
function _feeBusterAdjust(price, dept) {
  var gpiItem = purchaseService.feeBusterConfig.enabled && purchaseService.feeBusterConfig.manualinclusive && feebusterService.productPriceMustBeIncreased({
    dept: dept
  });
  var feeBusterAdjustedPrice = gpiItem ? round(price / (1 + purchaseService.feeBusterConfig.fraction)) : +price;
  if (gpiItem && feeBusterAdjustedPrice == price) {
    feeBusterAdjustedPrice--;
  }
  return Math.max(feeBusterAdjustedPrice, 1);
}
function _fetchActivePromos() {
  var promotions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  mypromos.length = 0;
  promotions.forEach(function (p) {
    p.maxoffers_orig = p.maxoffers;
    if (p.type == 'discount' || p.type == 'price') {
      mypromos.unshift(p);
    } else {
      mypromos.push(p);
    }
  });
  return mypromos;
}
function _generateDeliveryAsProduct(deliveryAmount, orderId) {
  return {
    byweight: false,
    dept: 'Delivery  Fees ',
    effectiveQuantity: 1,
    intCcPrice: deliveryAmount,
    intPrice: deliveryAmount,
    ismodifier: false,
    name: 'Delivery Fee',
    priceTaxFeeAdjustments: [],
    pricing: {},
    qty: 1,
    refund: false,
    revauths: [],
    showtext: "Delivery Fee (Order #".concat(orderId, ")"),
    skuprice: deliveryAmount,
    skuqty: 1,
    taxinc: false,
    upc: null
  };
}
function _generateModifierInfo(modifierList, itemGroupList, modifierGroups) {
  return modifierList.reduce(function (a, m) {
    var group = (modifierGroups.find(function (g) {
      return g.modifiers.find(function (md) {
        return md.upc == m.upc;
      }) && itemGroupList.indexOf(g.modifier_group) > -1;
    }) || {}).modifier_group;
    if (group) {
      var clone_modifier = Object.assign({}, m, {
        qty: m.pricing.qty,
        cents: m.pricing.cents / +m.pricing.qty
      });
      if (a[group]) {
        a[group].push(clone_modifier);
      } else {
        a[group] = [clone_modifier];
      }
    }
    return a;
  }, {});
}
function _getAuthorizedAmount(total) {
  var authorizationMultiplier = 1.1;
  var amount = round(total * authorizationMultiplier);
  return amount < 0 ? 0 : amount;
}
function _getDescriptions(p) {
  var promos = [];
  if (p.priceTaxFeeAdjustments && p.priceTaxFeeAdjustments.length) {
    p.priceTaxFeeAdjustments.forEach(function (a) {
      if (a.name === 'promo' && !a.extra.feeBuster) {
        /*
         * e2e tests require non-attained promos' div to contain 1 span and attained promos to
         * contain 2 spans
         */
        var description = [];
        var promo = a.extra.promo;
        var descriptionPrefix = _getPromoDescriptionPrefix(promo);
        /*
         * we don't always rely on the tier for qty / cents as it could be a promo from before the
         * promo-tier release
         */
        var promoQty = a.extra.tier ? a.extra.tier.qty : promo.pricing.qty;
        var promoCents = a.extra.tier ? a.extra.tier.cents : promo.pricing.cents;
        if (promo.type.search('percentdiscount') !== -1) {
          description = [descriptionPrefix, ' ' + promoCents + '% off ' + (promoQty == 1 ? 'each' : '/ ' + promoQty)];
        } else if (promo.type.search('discount') !== -1) {
          description = [descriptionPrefix, ' $' + _priceFilter(promoCents) + ' off ' + (promoQty == 1 || promo.type === 'mpr-discount' ? 'each' : '/ ' + promoQty)];
        }
        if (promo.type.match(/price$/)) {
          var feeBusterCoef = 1;
          var hasPriceIncrease = false;
          if (purchaseService.getPriceFn.withCcFee && purchaseService.priceIncrease) {
            var feebusterPtf = p.priceTaxFeeAdjustments.find(function (a) {
              return a.name === 'feebuster';
            });

            // only if feebuster price <> 0
            if (feebusterPtf && feebusterPtf.price) {
              hasPriceIncrease = true;
            }
          }
          if (hasPriceIncrease) {
            feeBusterCoef += purchaseService.feeBusterConfig.fraction;
          }
          if (promo.type.match(/^(mbq|mpr)/)) {
            description = [descriptionPrefix, ' Buy ' + promoQty + ' for $' + _priceFilter(promoCents * feeBusterCoef)];
          } else {
            var unitPrice = p.skuprice / p.skuqty;
            description = [descriptionPrefix, ' $' + _priceFilter((promoQty * unitPrice - promoCents) * feeBusterCoef) + ' off ' + (promoQty == 1 ? 'each' : '/ ' + promoQty)];
          }
        }
        if (promo.byweight && description[description.length - 1]) {
          description[description.length - 1] += ' lb';
        }
        var promoPrice = a.price * (p.refund ? -1 : 1);
        if (a.extra.addFeebuster) {
          var feebusterPromoPtf = p.priceTaxFeeAdjustments.find(function (b) {
            return a.name === b.name && a.id === b.id && b.extra.feeBuster;
          });
          if (feebusterPromoPtf) {
            promoPrice += feebusterPromoPtf.price;
          }
        }
        promos.push({
          description: description,
          price: _priceFilter(promoPrice)
        });
      }
    });
  }
  return promos;
}
function _getPromoDescriptionPrefix(promo) {
  if (promo.extpromoid) {
    return 'BR Promo';
  }
  if (promo.post_tax) {
    return 'Coupon' + (promo.coupon_campaign ? '-' + promo.coupon_campaign : '');
  }
  return 'Promotion';
}
function _isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function _pad(number, length) {
  var str = '' + number;
  while (str.length < length) {
    str = '0' + str;
  }
  return str;
}
function _priceFilter(cents, showmt) {
  if (null === cents) {
    return null;
  }
  if (!showmt && cents == 0) {
    return ''; //
  }
  if (!_isNumeric(cents)) {
    return cents;
  }
  var neg = '';
  if (cents < 0) {
    neg = '-';
    cents = -cents;
  }
  return neg + (cents / 100).toFixed(2);
}
function _setOverride(upc, qty, price) {
  myoverrides.forEach(function (ov) {
    if (ov.upc == upc) {
      ov.qty = qty;
      ov.price = price;
      return;
    }
  });
  myoverrides.push({
    upc: upc,
    qty: qty,
    price: price
  });
}
function _transformModifier(_ref2) {
  var name = _ref2.name,
    qty = _ref2.qty,
    cents = _ref2.cents;
  return {
    name: name,
    qty: qty,
    cents: cents
  };
}
function _transformProduct(product, i) {
  var _product$pricing, _product$pricing2, _product$pricing3, _product$pricing4, _product$pricing5;
  var calculatedQty = product.byweight ? product.qty * 100 : product.qty;
  var pricing = {
    qty: 1,
    cents: product.cents || 0,
    incltaxes: !!product.includes_taxes,
    inclfees: !!product.includes_fees,
    fee_multiplier: product.fee_multiplier || 1,
    byweight: !!product.byweight
  };
  return {
    byweight: !!product.byweight,
    dept: product.dept,
    disc: 0,
    feeinc: ((_product$pricing = product.pricing) === null || _product$pricing === void 0 ? void 0 : _product$pricing.inclfees) || pricing.inclfees,
    final_weight: null,
    isebt: (product.isebt === null ? product.deptisebt : product.isebt) || false,
    ismodifier: !!product.is_modifier,
    isRedemption: product.is_redemption,
    item_groups_list: product.modifier_groups,
    labeledprice: false,
    modifiers: product.modifiers,
    moreinfo: {},
    orderSequence: _pad(i, 4),
    picpak: product.extension ? product.extension.picpak : [],
    plu: null,
    price: ((_product$pricing2 = product.pricing) === null || _product$pricing2 === void 0 ? void 0 : _product$pricing2.cents) || pricing.cents,
    pricing: product.pricing || pricing,
    qty: calculatedQty,
    redemptionPointsOffer: product.redemption_points_offer || 0,
    redemptionPointsOfferId: product.redemption_points_offer_id || '',
    refund: !!product.refund,
    revauths: (product.pricebook_info || {}).revauths || product.revauths,
    showtext: product.name,
    size: product.size,
    skuprice: ((_product$pricing3 = product.pricing) === null || _product$pricing3 === void 0 ? void 0 : _product$pricing3.cents) || pricing.cents,
    skuqty: ((_product$pricing4 = product.pricing) === null || _product$pricing4 === void 0 ? void 0 : _product$pricing4.qty) || pricing.qty,
    taxinc: ((_product$pricing5 = product.pricing) === null || _product$pricing5 === void 0 ? void 0 : _product$pricing5.incltaxes) || pricing.incltaxes,
    upc: product.upc,
    uuid: product.item_id
  };
}
function _transformPurchase(purchase, excluded_depts) {
  feebusterService.neutralizeFeebusterCircularReference(purchase);
  var refundCoef = purchase.refund ? -1 : 1;
  var totals = (purchase.priceTaxFeeAdjustments || []).reduce(function (totals, ptfa) {
    // types: 'fee', 'feebuster', 'itemModifierPTF', priceoverride', promo', 'promobr' or 'tax'
    var type = ptfa.name + (ptfa.name === "promo" && ptfa.extra.promo.extpromoid ? "br" : "");
    // ptfa[ptfa.name] can be tax or fee. and it should be added to price it exist
    totals[type] = (totals[type] || 0) + (ptfa[ptfa.name] || 0) + (round(ptfa.price) || 0);
    return totals;
  }, {});
  return {
    byweight: purchase.byweight,
    dept: purchase.dept,
    descriptions: _getDescriptions(purchase),
    effectiveQuantity: purchase.effectiveQuantity,
    intCcPrice: purchase.intCcPrice && !excluded_depts.includes(purchase.dept) ? purchase.intCcPrice : purchase.intPrice,
    intPrice: purchase.intPrice,
    is_redemption: purchase.isRedemption,
    item_id: purchase.uuid,
    modifiers: purchase.modifiers ? purchase.modifiers.map(_transformModifier) : null,
    name: purchase.showtext,
    price: purchase.price,
    priceAfterPromos: purchase.getPrice() + (totals.promo * refundCoef || 0) + (totals.promobr || 0) + (totals.priceoverride * refundCoef || 0) + (redemptionsUpcList.indexOf(purchase.upc) > -1 ? totals.manualdiscount || 0 : 0) + (totals.itemModifierPTF * refundCoef || 0),
    /*
     * priceTaxFeeAdjustments note:
     * can not return when using a web worker because
     * priceTaxFeeAdjustment.feebuster.extra.cashPrice.getPrice is a
     * function and a function can not be posted
     */
    priceTaxFeeAdjustments: removeGetPriceFromFeebusterPTF(purchase.priceTaxFeeAdjustments) || [],
    priceWithModifiers: purchase.getPrice() + (totals.itemModifierPTF * refundCoef || 0),
    qty: purchase.qty,
    redemption_points_offer: purchase.redemptionPointsOffer,
    redemption_points_offer_id: purchase.redemptionPointsOfferId,
    refund: purchase.refund,
    revauths: purchase.revauths,
    taxinc: purchase.taxinc,
    showtext: purchase.showtext,
    skuprice: purchase.skuprice,
    skuqty: purchase.skuqty,
    totalbrpromo: totals.promobr || 0,
    totalfee: totals.fee || 0,
    totalinstorepromo: totals.promo || 0,
    totalmanualdiscount: (totals.manualdiscount || 0) + (totals.priceoverride || 0),
    totaltax: totals.tax || 0,
    upc: purchase.upc
  };
}

// Calculates the promo disc and returning totals & items array with new price/discounts
function calculateCart(_ref3) {
  var _points_config$exclud;
  var basket_data = _ref3.basket_data,
    basket_discount = _ref3.basket_discount,
    brnumber = _ref3.brnumber,
    driver_tip = _ref3.driver_tip,
    delivery_amount = _ref3.delivery_amount,
    extpromo_cloud_usage = _ref3.extpromo_cloud_usage,
    fee_buster_config = _ref3.fee_buster_config,
    first_order_discount = _ref3.first_order_discount,
    modifierGroups = _ref3.modifierGroups,
    order_id = _ref3.order_id,
    overrides = _ref3.overrides,
    points_config = _ref3.points_config,
    price_increase = _ref3.price_increase,
    products = _ref3.products,
    promotions = _ref3.promotions,
    service_fee = _ref3.service_fee,
    store_tip = _ref3.store_tip;
  extpromo_cloud_usage = extpromo_cloud_usage || [];
  promotions = promotions || [];

  // Handle fee buster config
  if (fee_buster_config) {
    purchaseService.feeBusterConfig = fee_buster_config;
  }

  // Handle points config
  if (points_config !== null && points_config !== void 0 && points_config.enabled && points_config !== null && points_config !== void 0 && (_points_config$exclud = points_config.excludedDepts) !== null && _points_config$exclud !== void 0 && _points_config$exclud.length) {
    purchaseService.pointsExcludedDepts = points_config.excludedDepts;
  }

  // Handle price increase config
  purchaseService.priceIncrease = price_increase.enabled;

  // Config purchaseService
  purchaseService.purchases.length = 0;
  if (brnumber) {
    purchaseService.reg.brnumber = brnumber;
  }

  // Prepare purchases
  products.forEach(function (p, i) {
    purchaseService.addItem(_transformProduct(p, i));
  });

  // Init intPrice for each item .
  // Important!!! this must be called before any other instruction
  purchaseService.getIntPricelist();

  // reset priceTaxFeeAdjusters
  purchaseService.priceTaxFeeAdjusters = [];

  // Set constants priceTaxFeeAdjusters
  purchaseService.priceTaxFeeAdjusters.push(new taxService.priceTaxFeeAdjuster());
  purchaseService.priceTaxFeeAdjusters.push(new feeService.priceTaxFeeAdjuster());
  purchaseService.priceTaxFeeAdjusters.push(new manualdiscountService.priceTaxFeeAdjuster());
  purchaseService.priceTaxFeeAdjusters.push(new priceoverrideService.priceTaxFeeAdjuster());
  (overrides === null || overrides === void 0 ? void 0 : overrides.length) && overrides.forEach(_doPriceOverride);

  // Handle feebuster config PTF
  if (price_increase.enabled) {
    purchaseService.priceTaxFeeAdjusters.push(new feebusterService.priceTaxFeeAdjuster({
      excludedDepts: price_increase.excludedDepts
    }));
  }

  // Handle driver tip
  if (driver_tip) {
    purchaseService.drivertip = driver_tip;
  }

  // Handle service fee
  if (service_fee) {
    purchaseService.servicefee = service_fee;
  }

  // Handle modifiers PTFs
  purchaseService.purchases.forEach(function (p) {
    _addModifiersPriceTaxFeeAdjusters(p, modifierGroups);
  });
  _addPromosPtfs(_fetchActivePromos(promotions));
  _adjustExternalPromos([], extpromo_cloud_usage);

  // Add loyalty PTFs
  purchaseService.purchases.forEach(function (p) {
    // Add loyalty (coffee) clubs PTFs
    if (p.isRedemption) {
      redemptionsUpcList.push(p.upc);
      purchaseService.priceTaxFeeAdjusters.push(new freeproductsService.priceTaxFeeAdjuster({
        type: 'upc',
        list: [p.upc],
        limit: p.qty,
        source: {
          name: 'coffeeclub',
          id: p.club_id,
          brnumber: brnumber
        }
      }));
    }
    if (p.redemptionPointsOfferId) {
      // Add loyalty points PTFs
      redemptionsUpcList.push(p.upc);
      purchaseService.priceTaxFeeAdjusters.push(new freeproductsService.priceTaxFeeAdjuster({
        type: 'upc',
        list: [p.upc],
        limit: p.qty,
        source: {
          name: 'points',
          id: p.redemptionPointsOfferId,
          brnumber: brnumber,
          pointsCost: p.redemptionPointsOffer
        }
      }));
    }
  });

  // Populate the PTFs
  _calculatePriceTaxFeeAdjusters();

  // Populate the promo net impact object
  // Must follow _calculatePriceTaxFeeAdjusters()
  purchaseService.refreshIntPromoPricelist({
    field: 'intPromoPriceTotals',
    purchaselist: purchaseService.purchases
  });
  fee_buster_config.enabled && purchaseService.refreshIntPromoPricelist({
    field: 'intPromoPriceTotalsCash',
    purchaselist: purchaseService.getCashPricePurchases()
  });

  // Handle store tip
  if (store_tip) {
    var subtotal = purchaseService.totals.subtotal();
    var cashSubtotal = purchaseService.totals.subtotal(cash = true);
    if (store_tip.tipstype === 'amt') {
      purchaseService.tipsInformations = _objectSpread(_objectSpread({}, store_tip), {}, {
        cashtipsamt: store_tip.tipsamt,
        tips: Math.round(store_tip.tipsamt / subtotal * 100)
      });
    } else {
      purchaseService.tipsInformations = _objectSpread(_objectSpread({}, store_tip), {}, {
        cashtipsamt: Math.round(cashSubtotal * store_tip.tips / 100),
        tipsamt: Math.round(subtotal * store_tip.tips / 100)
      });
    }
  }

  // Handle basket discount PTF
  if (basket_discount) {
    purchaseService.priceTaxFeeAdjusters = purchaseService.priceTaxFeeAdjusters.filter(function (a) {
      return a.name !== 'discountontotal';
    });
    purchaseService.priceTaxFeeAdjusters.push(new discountontotalService.priceTaxFeeAdjuster({
      discountType: basket_discount.discounttype,
      // "percentage" or "amt"
      discountAmount: basket_discount.discountamount,
      // number or undefined
      discountPercentage: basket_discount.discount,
      // number or undefined
      subtotal: purchaseService.totals.subtotal()
      // no need for useLowerItemPrices() here
    }));
  }

  // Handle first order discount PTF
  if (first_order_discount) {
    purchaseService.priceTaxFeeAdjusters = purchaseService.priceTaxFeeAdjusters.filter(function (a) {
      return a.name !== 'discountontotal';
    });
    var _subtotal = purchaseService.totals.subtotal();
    purchaseService.priceTaxFeeAdjusters.push(new discountontotalService.priceTaxFeeAdjuster({
      discountType: 'amt',
      discountAmount: Math.min(_subtotal, first_order_discount),
      discountPercentage: null,
      subtotal: _subtotal
      // no need for useLowerItemPrices() here
    }));
  }

  // Populate the PTFs
  _calculatePriceTaxFeeAdjusters();
  var items = purchaseService.purchases.reduce(function (a, p) {
    return Object.assign(a, _defineProperty({}, p.uuid, _transformPurchase(p, price_increase.excludedDepts)));
  }, {});
  if (delivery_amount) {
    var deliveryitem = _generateDeliveryAsProduct(delivery_amount, order_id);
    items.deliveryitem = deliveryitem;
  }
  return _export(items, {
    basket_data: basket_data,
    delivery_amount: delivery_amount
  });
} // calculateCart

function restoreCalc(basket, gpiConfig) {
  var _basket$overrides;
  // Config purchaseService
  if (gpiConfig.fee_buster_config) {
    purchaseService.feeBusterConfig = gpiConfig.fee_buster_config;
  }

  // Handle price increase config
  if (gpiConfig.price_increase.enabled) {
    purchaseService.priceIncrease = gpiConfig.price_increase.enabled;
  }

  // Reset priceTaxFeeAdjusters
  purchaseService.priceTaxFeeAdjusters = [];
  purchaseService.purchases.length = 0;

  // Prepare purchases
  basket.purchases.forEach(purchaseService.addItem);

  /* >>>>>>>>>>>>>>>>>> POS code to restore purchaseService >>>>>>>>>>>>>>>>> */
  var t = basket;
  var priceTaxFeeAdjustersTemp = t.priceTaxFeeAdjusters;

  /*
   * ["fee", "freeproducts", "promo", "tax"]
   * removed before zipped to cloud so won't find here
   */
  var ptfs = {
    discountontotal: promoService,
    feebuster: feebusterService,
    manualdiscount: manualdiscountService,
    itemModifierPTF: modifierService,
    priceoverride: priceoverrideService
  };
  t.priceTaxFeeAdjusters = [];
  var _iterator = _createForOfIteratorHelper(priceTaxFeeAdjustersTemp),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ptfData = _step.value;
      var service = ptfs[ptfData.name];
      var ptf = new service.priceTaxFeeAdjuster(ptfData.supplementalData, false);
      for (var prop in ptfData) {
        ptf[prop] = ptfData[prop];
      }
      t.priceTaxFeeAdjusters.push(ptf);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  t.priceTaxFeeAdjusters.push(new taxService.priceTaxFeeAdjuster());
  t.priceTaxFeeAdjusters.push(new feeService.priceTaxFeeAdjuster());

  // set the IDs of the purchase PTF-Adjustments match those of the purchase-service PTF-Adjusters
  t.priceTaxFeeAdjusters.filter(function (a) {
    return ['promo', 'tax', 'fee'].includes(a.name);
  }).forEach(function (PTF) {
    t.purchases.forEach(function (p) {
      if (p.priceTaxFeeAdjustments) {
        p.priceTaxFeeAdjustments.forEach(function (ptf) {
          // match pre-tax and post-tax promos using priority
          if (PTF.name === ptf.name && PTF.priority === ptf.priority) {
            ptf.id = PTF.id;
          }
        });
      }
    });
  });
  purchaseService.priceTaxFeeAdjusters = t.priceTaxFeeAdjusters;
  Object.assign(purchaseService.reg, t.reg);
  if (basket.brnumber) {
    purchaseService.reg.brnumber = basket.brnumber;
  }
  /* <<<<<<<<<<<<<<<<<< POS code to restore purchaseService <<<<<<<<<<<<<<<<< */

  ((_basket$overrides = basket.overrides) === null || _basket$overrides === void 0 ? void 0 : _basket$overrides.length) && basket.overrides.forEach(_doPriceOverride);

  // Need to handle modifiers PTFs?
  // purchaseService.purchases.forEach((p) => {
  //   _addModifiersPriceTaxFeeAdjusters(p, modifierGroups);
  // });

  // Populate the promo net impact object
  purchaseService.refreshIntPromoPricelist({
    field: 'intPromoPriceTotals',
    purchaselist: purchaseService.purchases
  });
  purchaseService.refreshIntPromoPricelist({
    field: 'intPromoPriceTotalsCash',
    purchaselist: purchaseService.getCashPricePurchases()
  });

  // Need to add loyalty PTFs?
  /*
  purchaseService.purchases.forEach((p) => {
    // Add loyalty (coffee) clubs PTFs
    if (p.isRedemption) {
      redemptionsUpcList.push(p.upc);
      purchaseService.priceTaxFeeAdjusters.push(
        new freeproductsService.priceTaxFeeAdjuster({
          type: "upc",
          list: [p.upc],
          limit: p.qty,
          source: {
            name: "coffeeclub",
            id: p.club_id,
            brnumber: purchaseService.brnumber,
          },
        }),
      );
    }
     if (p.redemptionPointsOfferId) {
      // Add loyalty points PTFs
      redemptionsUpcList.push(p.upc);
      purchaseService.priceTaxFeeAdjusters.push(
        new freeproductsService.priceTaxFeeAdjuster({
          type: "upc",
          list: [p.upc],
          limit: p.qty,
          source: {
            name: "points",
            id: p.redemptionPointsOfferId,
            brnumber: purchaseService.brnumber,
          },
        }),
      );
    }
  });
  */

  purchaseService.tipsInformations = {
    cashtipsamt: 0,
    tips: basket.tipsInformations.tips,
    tipstype: basket.tipsInformations.tipstype,
    tipsamt: basket.tipsInformations.tipsamt
  };

  // Want to handle basket discount PTF?
  // if (basket_discount) {
  //   purchaseService.priceTaxFeeAdjusters =
  //     purchaseService.priceTaxFeeAdjusters.filter(
  //       (a) => a.name !== "discountontotal",
  //     );
  //   purchaseService.priceTaxFeeAdjusters.push(
  //     new discountontotalService.priceTaxFeeAdjuster({
  //       discountType: basket_discount.discounttype, // "percentage" or "amt"
  //       discountAmount: basket_discount.discountamount, // number or undefined
  //       discountPercentage: basket_discount.discount, // number or undefined
  //       subtotal: purchaseService.totals.subtotal(),
  //       // no need for useLowerItemPrices() here
  //     }),
  //   );
  // }

  // Populate the PTFs
  _calculatePriceTaxFeeAdjusters();
  var items = purchaseService.purchases.reduce(function (a, p) {
    return Object.assign(a, _defineProperty({}, p.uuid, _transformPurchase(p, gpiConfig.price_increase.excludedDepts)));
  }, {});
  return _export(items, {
    basket_data: true,
    delivery_amount: null
  });
} // restoreCalc

module.exports = {
  calculateCart: calculateCart,
  restoreCalc: restoreCalc
};